var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8104 26.0621V44.9995L23.8239 38.9482L29.8374 44.9995V25.3354",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8104 26.0621V44.9995L23.8239 38.9482L29.8374 44.9995V25.3354",
    stroke: "#2EBB49",
    strokeWidth: 1.71814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0678 25.0692L29.47 25.1036L27.7673 28.2737L24.5647 26.6328L21.5837 28.6465L19.5116 25.7084L15.9362 26.1037L15.4671 22.5385L12.1167 21.2292L13.3572 17.8531L10.9999 15.1368L13.6682 12.7244L12.8435 9.22288L16.3262 8.32595L17.2213 4.84332L20.7229 5.66799L23.1352 2.99976L25.8516 5.35874L29.2277 4.11659L30.5369 7.46688L34.1038 7.93595L33.7069 11.5114L36.6449 13.5852L34.633 16.5662L36.2721 19.7671L33.1038 21.4715L33.0678 25.0692Z",
    fill: "#E9FFED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0678 25.0692L29.47 25.1036L27.7673 28.2737L24.5647 26.6328L21.5837 28.6465L19.5116 25.7084L15.9362 26.1037L15.4671 22.5385L12.1167 21.2292L13.3572 17.8531L10.9999 15.1368L13.6682 12.7244L12.8435 9.22288L16.3262 8.32595L17.2213 4.84332L20.7229 5.66799L23.1352 2.99976L25.8516 5.35874L29.2277 4.11659L30.5369 7.46688L34.1038 7.93595L33.7069 11.5114L36.6449 13.5852L34.633 16.5662L36.2721 19.7671L33.1038 21.4715L33.0678 25.0692Z",
    stroke: "#2EBB49",
    strokeWidth: 1.71814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8222 21.837C27.1433 21.837 29.8357 19.1447 29.8357 15.8235C29.8357 12.5024 27.1433 9.81003 23.8222 9.81003C20.501 9.81003 17.8087 12.5024 17.8087 15.8235C17.8087 19.1447 20.501 21.837 23.8222 21.837Z",
    fill: "white",
    stroke: "#2EBB49",
    strokeWidth: 1.71814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3693 18.3486L23.783 17.9024L22.1836 18.3002L22.1177 16.6527L21.2452 15.2539L22.7909 14.6823L23.8511 13.4196L24.8723 14.7133L26.3999 15.3321L25.4855 16.7036L25.3693 18.3486Z",
    stroke: "#2EBB49",
    strokeWidth: 1.71826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8239 39.9396V27.0295",
    stroke: "#2EBB49",
    strokeWidth: 1.71814
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.acbad8051f3e4271c5a1fb30ca5f44f9.svg";
export { ForwardRef as ReactComponent };